<template src='./organization-information.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { EventBus } from '@/router/bus'
import { hasAdminClaim, hasOrganizationRegistrationResolveClaim, hasOrganizationManageClaim } from '@/router/auth.js'
import Vuelidate from 'vuelidate'
import { required, maxLength, requiredIf, helpers } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'

Vue.use(Vuelidate)

const contactSeparatorRegex = /(?:,|;| )+/

export default {
  components: {
    ContextPage
  },
  mixins: [validationMixin],
  data () {
    return {
      organizationId: this.$route.params.organizationId,
      OrganizationRequestRespond: {
        Approve: 1,
        Deny: 2
      },
      organization: {
        adminLogin: '',
        nameShort: '',
        supportPhoneNumbers: '',
        supportEmails: ''
      },
      pageLoader: false,
      generateLogin: true,
      notifyAdmin: true,
      organizationStatus: {
        PENDING: 1,
        APPROVED: 2,
        CANCELLED: 3
      },
      help: {
        details: Vue.$helpConfig.organizationDetails
      },
      status: [
        {
          color: 'pending',
          text: this.$t('organizationAdministration.statusNames.PENDING')
        },
        {
          color: 'success',
          text: this.$t('organizationAdministration.statusNames.APPROVED')
        },
        {
          color: 'error',
          text: this.$t('organizationAdministration.statusNames.CANCELLED')
        }
      ],
      validateUrl_admin: Vue.$apiConfig.validateUserGet
    }
  },
  created () {
    this.setupPage()
  },
  computed: {
    displayAdminPrintButton () {
      return (hasAdminClaim() || hasOrganizationRegistrationResolveClaim()) && this.organization.status === this.organizationStatus.APPROVED
    },
    canResolveOrganizationRequest () {
      return hasOrganizationRegistrationResolveClaim()
    },
    canEditOrganization () {
      return hasOrganizationManageClaim()
    },
    adminLoginErrors () {
      return this.getValidationErrorsByName('adminLogin')
    },
    nameShortErrors () {
      return this.getValidationErrorsByName('nameShort')
    },
    supportEmailsErrors () {
      return this.getValidationErrorsByName('supportEmails')
    },
    supportPhoneNumbersErrors () {
      return this.getValidationErrorsByName('supportPhoneNumbers')
    }
  },
  watch: {
    generateLogin (val) {
      if (this.organization.adminName) {
        if (!val) {
          this.getUniqueLogin(this.organization.adminName)
        }
      } else {
        this.organization.adminLogin = ''
      }
    }
  },
  methods: {
    setupPage () {
      this.pageLoader = true
      const infoUrl = Vue.$apiConfig.organizationDetailsGet + '/' + this.$route.params.organizationId
      this.$http.get(infoUrl).then(
        response => {
          this.logConsole(response)
          this.organization = response.data.payload
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    },
    validateBeforeChangeNameShort () {
      this.$v.$touch()
      console.log(this.$t('errors.someErrorsOccuredCheckListBelow'))
      if (this.$v.$invalid) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('organization')
        })

        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.changeNameShort()
    },
    changeNameShort () {
      this.pageLoader = true
      console.log(this.pageLoader)
      const splitSupportEmails = this.organization.supportEmails ? this.organization.supportEmails.split(contactSeparatorRegex) : null
      const splitSupportPhoneNumbers = this.organization.supportPhoneNumbers ? this.organization.supportPhoneNumbers.split(contactSeparatorRegex) : null
      this.$http.put(Vue.$apiConfig.organizationUpdatePut.replace('{id}', this.$route.params.organizationId), { ...this.organization, supportEmails: splitSupportEmails, supportPhoneNumbers: splitSupportPhoneNumbers })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.organization.status = payload.status
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('organizationAdministration.updateSuccessful'),
              errors: []
            })
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    validateBeforeApprove () {
      this.$v.$touch()
      console.log(this.$t('errors.someErrorsOccuredCheckListBelow'))
      if (this.$v.$invalid) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('organization')
        })

        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.approveRegistration()
    },
    approveRegistration () {
      this.pageLoader = true
      console.log(this.pageLoader)
      this.organization.respond = this.OrganizationRequestRespond.Approve
      this.organization.treasuryBranchCode = this.organization.treasuryBranchCode.toString()
      this.organization.comment = this.activationComment
      this.organization.generateLogin = this.generateLogin
      this.organization.notifyAdmin = this.notifyAdmin
      const splitSupportEmails = this.organization.supportEmails ? this.organization.supportEmails.split(contactSeparatorRegex) : null
      const splitSupportPhoneNumbers = this.organization.supportPhoneNumbers ? this.organization.supportPhoneNumbers.split(contactSeparatorRegex) : null
      this.$http.post(Vue.$apiConfig.organizationApprovePost.replace('{id}', this.$route.params.organizationId), { ...this.organization, supportEmails: splitSupportEmails, supportPhoneNumbers: splitSupportPhoneNumbers })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.organization.status = payload.status
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('organizationAdministration.approvalSuccessful'),
              errors: []
            })
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    cancelRegistration () {
      this.pageLoader = true
      console.log(this.pageLoader)
      this.organization.respond = this.OrganizationRequestRespond.Deny
      this.organization.treasuryBranchCode = this.organization.treasuryBranchCode.toString()
      const splitSupportEmails = this.organization.supportEmails ? this.organization.supportEmails.split(contactSeparatorRegex) : null
      const splitSupportPhoneNumbers = this.organization.supportPhoneNumbers ? this.organization.supportPhoneNumbers.split(contactSeparatorRegex) : null
      this.$http.post(Vue.$apiConfig.organizationCancelPost.replace('{id}', this.$route.params.organizationId), { ...this.organization, supportEmails: splitSupportEmails, supportPhoneNumbers: splitSupportPhoneNumbers })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.organization.status = payload.status
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('organizationAdministration.cancellationSuccessful'),
              errors: []
            })
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    prepareUserResponseData (data) {
      return data.body.payload
    },
    getUniqueLogin (name) {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.generateLogin + '?name=' + name).then(
        response => {
          this.logConsole(response)
          this.organization.adminLogin = response.data.payload
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    },
    printRegistration () {
      this.exportRegistration(this.organization, this.$refs.imgToExport)
    },
    printAdminForm () {
      this.exportAdminForm(this.organization, this.$refs.imgToExport)
    },
    getValidationErrorsByName (name) {
      if (!this.$v.organization[name].$dirty) return []
      return this.getValidationErrors('organization').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations () {
    const rules = {}
    const phoneRegex = /^(\d|-|\(|\)|\/|\\|\+){9,20}$/
    helpers.regex('phone', phoneRegex)
    const supportPhoneNumbers = (value) => {
      if (!value || value.length === 0) return true

      const splitPhones = value.split(contactSeparatorRegex)
      for (let i = 0; i < splitPhones.length; i++) {
        if (!phoneRegex.test(splitPhones[i])) return false
      }

      return true
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    const supportEmails = (value) => {
      if (!value || value.length === 0) return true

      const splitEmails = value.split(contactSeparatorRegex)
      for (let i = 0; i < splitEmails.length; i++) {
        if (!emailRegex.test(splitEmails[i])) return false
      }

      return true
    }

    Object.assign(rules, {
      adminLogin: {
        required: requiredIf(function () {
          return !this.generateLogin
        }),
        maxLength: maxLength(32)
      },
      nameShort: {
        required,
        maxLength: maxLength(10)
      },
      supportEmails: {
        maxLength: maxLength(1000),
        supportEmails
      },
      supportPhoneNumbers: {
        maxLength: maxLength(1000),
        supportPhoneNumbers
      }
    })

    return {
      organization: rules
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}

  .list-dense {
    min-height: 26px !important;
    padding-left: 0px !important;
  }
  .list-icon {
    padding: 2px 0px !important;
    margin-right: 16px !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }

  .list-contents {
    padding: 2px 0px !important;
  }

  .v-list-item__title {
    font-weight: 400 !important;
  }

</style>
